import { render } from "./ClearIndicator.vue?vue&type=template&id=d0af0118"
import script from "./ClearIndicator.vue?vue&type=script&lang=js"
export * from "./ClearIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__